import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/PersonAddDisabled';
import Info from '@material-ui/icons/InfoOutlined';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import AlertDialog from '../../components/AlertDialog/AlertDialog';
// import Snackbar from '@material-ui/core/Snackbar';

import { fetchEmployees, updateEmployee } from '../../store/actions/employee';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';

const styles = theme => ({
  header: {
    marginBottom: theme.spacing(3),
    paddingLeft: 10,
    paddingTop: 5,

  },
  title: {
    marginBottom: theme.spacing(3),
    paddingLeft: 10,
    display: 'flex',

  },
  titleGestor: {
    paddingLeft: 10,
    paddingTop: 5,
    display: 'flex',
    alignItems: 'center',
  },
  paper: {

  },
  titleCompany: {
    marginBottom: theme.spacing(3),
    color: '#537ccd',
    paddingLeft: 10,
  },
  premium: {
    fontWeight: theme.typography.fontWeightStrong,
  },
});

class Users extends React.Component {
  state = {
    openModal: false,
    searchQuery: '',
    currentAction: null,
    currentItem: {
      id: null,
      name: '',
      isManager: null,
    },
    snackOpen: true,
    userIdNull: false,
    openDialog: false,
    validaetPremium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
  }

  componentDidMount() {
    this.props.onFetchEmployees();
  }

  // handleActionClick = (action, item) => {
  //   if (item) {
  //     this.setState({ openModal: true, currentItem: item, currentAction: action });
  //   } else {
  //     this.setState({
  //       openModal: true,
  //       currentItem: { id: null, isManager: null },
  //       currentAction: action,
  //     });
  //   }
  // };

  handleOpenDialog = () => {
    this.setState({ openDialog: true });
  }

  onCloseModal = () => {
    this.setState({ openDialog: false });
  }

  handleActionAdd = () => {
    this.setState({ openModal: true, currentAction: 'Adicionar' });
  }

  handleSnackClose = () => {
    this.setState({ snackOpen: false });
  };

  handleSnackExited = () => {
    // this.props.onClearMessage();
    this.setState({ snackOpen: true });
  };
  handleAddGest = (item) => {
    const { employees } = this.props;
    item.isManager = true;
    if (!this.state.validaetPremium && this.props.gestors.length >= 1) {
      this.handleOpenDialog();
    } else {
      if (item.userId !== null) {
        // this.props.onUpdateEmployee(item)
        this.props.onUpdateEmployee(item, 'Gestor adicionado com sucesso')
          .then(() => {
            this.props.onFetchEmployees()
            this.setState({ gestors: employees.filter(employee => employee.isManager), openModal: false })
          }
          )
        // .then();
      } else {
        this.state.userIdNull = true;
        // alert('O funcionário precisa ter um userId para se tornar gestor');
      }
      this.handleActionAdd();
    }
  }


  handleActionCancel = () => {
    this.setState({ openModal: false, searchQuery: '', userIdNull: false });
  };

  handleInputChange = name => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleDeleteClick = (item) => {
    this.setState({
      openModal: true,
      currentItem: item,
      currentAction: 'Remover',
    });
  };

  handleActionConfirm = () => {
    this.props.onUpdateEmployee({ id: this.state.currentItem.id, isManager: false }, 'Gestor removido com sucesso')
      .then(() => this.props.onFetchEmployees());

    this.handleActionCancel();
  };

  render() {
    const {
      classes, employees, loading, socialName, gestors,
    } = this.props;

    const { searchQuery, currentAction } = this.state;

    const columns = [
      { name: 'name', label: 'Nome' },
      { name: 'department', label: 'Departamento' }
    ];

    let gestorsAlphabetic = gestors.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    const searchFields = ['name'];

    const actions = [
      {
        name: 'Tornar gestor',
        icon: AddIcon,
        onClick: item => this.handleAddGest(item),
      },
    ];
    const actionsGest = [
      {
        name: 'Remover como Gestor',
        icon: DeleteIcon,
        onClick: item => this.handleDeleteClick(item),
      },
    ];

    const filteredRows = employees.filter((employee) => {
      let hasField = false;
      searchFields.forEach((searchField) => {
        if (employee.isManager === false && employee.userId !== null) {
          hasField = hasField || employee[searchField].includes(searchQuery.toUpperCase());
        }
      });
      return hasField;
    });

    return (
      <React.Fragment>
        <ContentHeader
          title="Gestores"
          subtitle="Perfis que podem acessar o Puntu gestor"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.handleActionAdd()}
          >
            <AddIcon /> ADICIONAR
          </Button>
        </ContentHeader>

        <Paper elevation={2} className={classes.paper} >
          <Typography variant="h6" className={classes.header} >
            Administrador
            <span className={classes.titleCompany}>
              {socialName}
            </span>
          </Typography>
          <Divider />
          <Typography variant="h6" color="textSecondary" className={classes.title}>
            Gestores
            <Tooltip title="Funcionários que podem acessar o perfil da empresa" >
              <span className={classes.titleGestor}> <Info color="primary" /> </span>
            </Tooltip>

          </Typography>
          <DataTable
            rows={gestorsAlphabetic}
            columns={columns}
            loading={loading}
            actions={actionsGest}
          />
        </Paper>


        <Dialog open={this.state.openModal} onClose={this.handleActionCancel}>
          <DialogTitle> Escolha um Gestor</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {currentAction === 'Remover'
                ? 'Você tem certeza que deseja efetuar esta ação?'
                : 'Escolha um funcionário para se tornar um gestor'}
              {/* Escolha um funcionário para se tornar um gestor */}
            </DialogContentText>
            {/*Caso o userId seja null deixara a mensagem vermelha */}
            {currentAction !== 'Remover' ?
              <DialogContentText  style=
                    {{
                      fontSize: '14px',
                      color: 'white',
                      backgroundColor: '#1a8fff',
                      borderRadius: '4px',
                      padding: '25px',
                    }}
                   >
                  Para se tornar gestor o funcionário precisa ter um usuário cadastrado no nosso sistema!
                  Se acaso o funcionário não tiver cadastro, você pode enviar esse link:
                   <a href="https://app.puntu.digital/registrar-empregado">https://app.puntu.digital/registrar-empregado</a>
                 {' '}  ou ele pode baixar nosso app para criar seu usuário!
                
                
              </DialogContentText> : ""}

            {currentAction !== 'Remover' ? (
              <React.Fragment>
                <TextField
                  className={classes.input}
                  value={searchQuery}
                  onChange={this.handleInputChange('searchQuery')}
                  placeholder="Buscar"
                  type="text"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    ),
                  }}
                />
                <DataTable 
                  rows={filteredRows}
                  columns={columns}
                  loading={loading}
                  actions={actions}
                />

                <AlertDialog
                  title="Atenção"
                  text={<Link style={{ textDecoration: 'none' }} to="/assinatura">
                    <Typography color="primary" className={classes.premium}>
                      Seja assinante e adicione quantos gestores precisar.
                    </Typography>
                  </Link>}
                  open={this.state.openDialog}
                  onClose={this.onCloseModal}
                >
                </AlertDialog>
              </React.Fragment>


            ) : null}

          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            {currentAction === 'Remover' ? (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.handleActionConfirm}
                autoFocus={currentAction === 'Remover'}
              >
                CONFIRMAR
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>

      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  employees: state.employee.employees,
  socialName: state.data.data.socialName,
  gestors: state.employee.employees.filter(employee => employee.isManager),
});

const mapDispatchToProps = dispatch => ({
  onFetchEmployees: () => dispatch(fetchEmployees()),
  onUpdateEmployee: (employee, message) => dispatch(updateEmployee(employee, message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Users));

